const appendScripts = (scriptsString, holder = document.body, callback) => {
  const temp = document.createElement("div");
  temp.innerHTML = scriptsString;
  const scriptSet = [];
  const scriptPromises = [];
  const headScripts = temp.querySelectorAll("script");
  (headScripts || []).forEach((headScript) => {
    const script = document.createElement("script");
    script.setAttribute("defer", "true");
    if (headScript.type) {
      script.type = headScript.type;
    }
    if (headScript.src) {
      script.src = headScript.src;
      const scriptLoadedPromise = new Promise((resolve, reject) => {
        script.onload = () => resolve(headScript.src);
        script.onerror = (error) => reject(error);
      });
      scriptPromises.push(scriptLoadedPromise);
    }
    if (headScript.innerHTML) {
      script.innerHTML = headScript.innerHTML;
    }
    scriptSet.push(script);
    script.remove();
  });
  scriptSet.forEach((script) => {
    try {
      holder.appendChild(script);
    } catch (e) {
      console.error(e);
    }
  });
  const results = [];
  let promiseChain = Promise.resolve();
  scriptPromises.forEach((promise) => {
    promiseChain = promiseChain.then(() => promise).then((result) => {
      results.push(result);
    }).catch((error) => {
      console.info("error", error);
    });
  });
  promiseChain.then(() => {
    if (callback) {
      callback(results);
    }
  });
  temp.remove();
};
export {
  appendScripts
};
